function validateIVChecks(caseConf, nodeInfo) {

  const { iv } = caseConf;

  const errors = [];
  const warnings = [];

  nodeInfo.checkNodes.forEach((node) => {
    Object.entries(node.data).forEach((entry) => {
      const checkKey = entry[0];
      const check = entry[1];

      if (check && check.type === 'IV_PLACED') {
        // IV enabled
        if (!iv || !iv.enabled) {
          warnings.push(ivWarning('IV is used in case logic but is not enabled'));
          warnings.push(caseLogicWarning('IV is not enabled', node.id, checkKey));
        } else {
          // Type/Category
          if (check.category) {
            const type = iv.types.find(t => t.type === check.category);
            if (!type || !type.sites.length) {
              warnings.push(ivWarning('IV type is used in case logic but is not enabled', 'type', check.category));
              warnings.push(caseLogicWarning('IV type is not enabled', node.id, checkKey, 'type'));
            }
          }

          const allSites = iv.types.reduce((accumulator, currentValue) => {
            if (!check.category || currentValue.type === check.category) {
              return accumulator.concat(currentValue.sites);
            }
            return accumulator;
          }, []);

          // Sites
          check.sites.forEach((site) => {
            if (!allSites.find(s => s.site === site)) {
              warnings.push(ivWarning('IV site is used in case logic but is not enabled', 'site', check.category, site));
              warnings.push(caseLogicWarning('IV site is not enabled', node.id, checkKey, 'site'));
            }
          });

          // Sides
          const hasLeftOptions = !!allSites.find(site => site.sides.includes('LEFT'));
          const hasRightOptions = !!allSites.find(site => site.sides.includes('RIGHT'));
          (check.sides || []).forEach((side) => {
            if (side === 'LEFT' && !hasLeftOptions) {
              warnings.push(ivWarning('IV side is used in case logic but is not enabled', 'side', check.category, undefined, side));
              warnings.push(caseLogicWarning('IV side is not enabled', node.id, checkKey, 'side'));
            }
            if (side === 'RIGHT' && !hasRightOptions) {
              warnings.push(ivWarning('IV side is used in case logic but is not enabled', 'side', check.category, undefined, side));
              warnings.push(caseLogicWarning('IV side is not enabled', node.id, checkKey, 'side'));
            }
          });

          // Needle gauges
          const peripheral = iv.types.find(type => type.type === 'PERIPHERAL');
          check.needleGauges.forEach((gauge) => {
            if (!peripheral || !peripheral.gauges.includes(gauge)) {
              warnings.push(ivWarning('IV needle gauge is used in case logic but is not enabled', 'needleGauge'));
              warnings.push(caseLogicWarning('IV needle gauge is not enabled', node.id, checkKey, 'gauge'));
            }
          });

          // Needle sets
          const intraosseous = iv.types.find(type => type.type === 'INTRAOSSEOUS');
          check.needleSets.forEach((set) => {
            if (!intraosseous || !intraosseous.gauges.includes(set)) {
              warnings.push(ivWarning('IV needle set is used in case logic but is not enabled', 'needleSet'));
              warnings.push(caseLogicWarning('IV needle set is not enabled', node.id, checkKey, 'set'));
            }
          });

          // Saline Lock
          let isSalineLock = false;
          for (const type of iv.types) {
            if (!check.category || type.type === check.category) {
              isSalineLock |= type.salineLock;
            }
          }
          if (check.isSalineLock && !isSalineLock) {
            warnings.push(ivWarning('IV saline lock is used in case logic but is not enabled', 'salineLock', check.category));
            warnings.push(caseLogicWarning('IV saline lock is not enabled', node.id, checkKey, 'salineLock'));
          }

          // Two Ports
          let availablePorts = {};
          for (const type of iv.types) {
            if (!check.category || type.type === check.category) {
              for (const port of type.ports) {
                availablePorts[port] = true;
              }
            }
          }
          for (const port of check.ports) {
            if (!availablePorts[port]) {
              warnings.push(ivWarning('IV port is used in case logic but is not enabled', 'port', check.category));
              warnings.push(caseLogicWarning('IV port is not enabled', node.id, checkKey, 'port'));
              break;
            }
          }
        }
      }
    });
  });

  return {
    errors,
    warnings,
  };
}

function ivWarning(message, id, type, site, side) {
  return {
    message,
    category: 'ivs',
    field: 'iv',
    id,
    metadata: {
      type,
      site,
      side,
      scope: 'control',
    },
  };
}

function caseLogicWarning(message, nodeId, checkId, componentId) {
  return {
    message,
    category: 'caseLogic',
    field: 'caseLogicDescription',
    id: nodeId,
    metadata: {
      checkId,
      componentId,
      scope: 'control',
    },
  };
}

export default validateIVChecks;
